import { generateImageUrl } from '@msdyn365-commerce-modules/retail-actions';
import { IWebGroupSearchItem } from '../webgroup-search-results';
import { IWebgroupSearchResultsConfig } from '../webgroup-search-results.props.autogenerated';

import * as Msdyn365 from '@msdyn365-commerce/core';

export type Props = Omit<
    IWebGroupSearchItem & { title: string; config: IWebgroupSearchResultsConfig; context: Msdyn365.IActionContext },
    'image'
>;

export function getImageUrls(props: Props, path: 'Categories' | 'Products', isWebgroup = false) {
    const { context, Name, id } = props;
    const placeholder = 'placeholder.png';
    const fallBack =
        props.config.fallbackImage?.src ??
        generateImageUrl(placeholder, props.context.requestContext.apiSettings)?.replace(`/${placeholder}`, placeholder);
    const image = `${generateImageUrl(
        path === 'Categories' ? `${path}/${Name}.png` : `${path}/${isWebgroup ? 'wg_' : ''}${id}${isWebgroup ? '' : '_000_001'}.png`,
        context.requestContext.apiSettings
    )}&w=250&q=40&f=jpg`;

    return {
        name: Name,
        image,
        fallBack,
        encodedImage:
            path === 'Categories'
                ? `${generateImageUrl(
                      `${path}/${encodeURIComponent(Name ?? '')}.png`,
                      props.context.requestContext.apiSettings
                  )}&w=250&q=40&f=jpg`
                : undefined
    };
}
